import React, { useState, useRef, useEffect } from "react";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { format, parseISO } from "date-fns";
import { enUS } from "react-date-range/dist/locale";
import {
  getFinancialYearEndDate,
  getFinancialYearStartDate,
  getLastDateOfMonth,
} from "../Utility/utilis";

export const DropdownDateRangePicker = ({
  initialStartDate,
  initialEndDate,
  minDate,
  maxDate,
  width,
  dateRange,
  setDateRange,
  formatDateRecoTab,
  tab,
  selection,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [hasUserSelected, setHasUserSelected] = useState(false);

  // Initialize with valid default dates to prevent Invalid interval errors
  // but mark as not user-selected
  useEffect(() => {
    if (
      !dateRange ||
      dateRange.length === 0 ||
      dateRange[0].startDate === null ||
      dateRange[0].endDate === null
    ) {
      const currentYear = new Date().getFullYear();
      const defaultStart = new Date(currentYear, 3, 1); // April 1st
      const defaultEnd = new Date(currentYear + 1, 2, 31); // March 31st next year

      setDateRange([
        {
          startDate: defaultStart,
          endDate: defaultEnd,
          key: "selection",
        },
      ]);
    }
  }, []);

  const handleSelect = (ranges) => {
    setDateRange([ranges.selection]);
    setHasUserSelected(true);
  };
  // Don't automatically set API values - only set after user interaction
  // This prevents showing dates initially, similar to reconciliation version

  const toggleDropdown = () => {
    setIsOpen(true);
  };

  const handleOutsideClick = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  const handleClear = () => {
    setHasUserSelected(false);
    // Keep valid dates for DateRange component but don't display them
    const currentYear = new Date().getFullYear();
    const defaultStart = new Date(currentYear, 3, 1); // April 1st
    const defaultEnd = new Date(currentYear + 1, 2, 31); // March 31st next year

    setDateRange([
      {
        startDate: defaultStart,
        endDate: defaultEnd,
        key: "selection",
      },
    ]);
  };

  React.useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  // Cleanup on unmount - clear states and selection
  useEffect(() => {
    return () => {
      setHasUserSelected(false);
      setDateRange([
        {
          startDate: null,
          endDate: null,
          key: "selection",
        },
      ]);
    };
  }, []);

  const formatDate = (date) => {
    if (!date) return "";
    if (typeof date === "string") {
      try {
        return format(parseISO(date), "dd MMM");
      } catch {
        console.error("Invalid ISO date string:", date);
        return "";
      }
    }
    if (date instanceof Date && !isNaN(date.getTime())) {
      return format(date, "dd MMM");
    }
    console.error("Invalid date value:", date);
    return "";
  };

  const { startDate, endDate } =
    dateRange && dateRange.length > 0 && dateRange[0]
      ? dateRange[0]
      : { startDate: null, endDate: null };

  useEffect(() => {
    console.log("Initial Start Date:", initialStartDate);
    console.log("Initial End Date:", initialEndDate);
  }, [initialStartDate, initialEndDate]);

  return (
    <div
      style={{ position: "relative", width: width ? width : "203px" }}
      ref={dropdownRef}
    >
      <div
        style={{
          height: "38px",
          width: "167px",
          marginTop: "10px",
        }}
      >
        <button
          onClick={toggleDropdown}
          style={{
            width: "110%",
            height: "102%",
            paddingTop: "5px",
            paddingBottom: "5px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            backgroundColor: "#fff",
            textAlign: "center",
            cursor: "pointer",
          }}
        >
          {hasUserSelected && startDate && endDate ? (
            `${formatDate(startDate)} - ${formatDate(endDate)}`
          ) : (
            <div style={{ display: "flex" }}>
              <span
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  color: "#000000ff",
                }}
              >
                Select Date Range
              </span>
            </div>
          )}
        </button>
        {isOpen && (
          <div
            style={{
              position: "absolute",
              left: 0,
              zIndex: 1000,
              backgroundColor: "#fff",
              border: "1px solid #ccc",
              borderRadius: "5px",
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
              transform: "scale(0.8)",
              transformOrigin: "top left",
            }}
          >
            <DateRange
              editableDateInputs={true}
              onChange={handleSelect}
              moveRangeOnFirstSelection={false}
              ranges={dateRange}
              showDateDisplay={false}
              // minDate={
              //   minDate
              //     ? (() => {
              //         const result = getFinancialYearStartDate(minDate);
              //         return result instanceof Date && !isNaN(result.getTime())
              //           ? result
              //           : undefined;
              //       })()
              //     : undefined
              // }
              // maxDate={
              //   maxDate
              //     ? (() => {
              //         const result = getFinancialYearEndDate(maxDate);
              //         return result instanceof Date && !isNaN(result.getTime())
              //           ? result
              //           : undefined;A
              //       })()
              //     : undefined
              // }
               minDate={new Date(2015, 0, 1)}
            maxDate={new Date(new Date().getFullYear() + 5, 11, 31)}
              rangeColors={["#6B46C1"]}
              locale={enUS}
              styles={{
                calendarWrapper: { transform: "scale(0.8)" },
              }}
            />
            <div
              style={{
                marginRight: "12px",
                marginBottom: "3px",
                textAlign: "centre",
                cursor: "pointer",
                color: "#6B46C1",
                fontSize: "14px",
                fontWeight: "bold",
              }}
              onClick={handleClear}
            >
              Clear
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
